import type { ILikeCounterResources } from "./LikeCounter.Resources";

export const LikeCounterResourcesEn: ILikeCounterResources = {
  coolResource: "COOL",
  counterDescription: "Likes:",
};
